import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlockAlt, faGem } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

/**
 * 鎖定貼文的解鎖／訂閱按鈕，依 lockType 二選一。貼文與偶像頁媒體 tab 共用，
 * 確保兩邊的文案、icon、樣式完全一致。
 *
 * 不傳 onUnlockClick／onSubscribeClick 時視為純裝飾（媒體 tab、貼文預覽卡都是整張／整格
 * 接手點擊），除了擋掉滑鼠事件，也一併移出 tab 順序並對輔具隱藏，
 * 避免鍵盤與螢幕閱讀器使用者遇到一堆按了沒有反應的死控制項。
 *
 * 定位由呼叫端決定（貼文壓在整組媒體中央，媒體 grid 壓在單格中央）。
 */
const UnlockButton = ({ lockType, unlockPrice, onUnlockClick, onSubscribeClick, size = '' }) => {
  const { t } = useTranslation();

  const isUnlock = lockType === 'unlock' && !!unlockPrice;
  const isSubscribe = lockType === 'subscribe';
  if (!isUnlock && !isSubscribe) return null;

  const onClick = isUnlock ? onUnlockClick : onSubscribeClick;
  const decorative = !onClick;

  const buttonProps = {
    className: `btn btn-primary rounded-pill fw-bold text-nowrap ${size ? `btn-${size}` : ''}`.trim(),
    onClick: onClick || undefined,
    style: decorative ? { pointerEvents: 'none' } : undefined,
    tabIndex: decorative ? -1 : undefined,
    'aria-hidden': decorative ? true : undefined,
  };

  if (isUnlock) {
    return (
      <button {...buttonProps}>
        <FontAwesomeIcon icon={faUnlockAlt} className="me-2" />
        {t('unlock_post')} ₣{unlockPrice} FCoin
      </button>
    );
  }

  return (
    <button {...buttonProps}>
      <FontAwesomeIcon icon={faGem} className="me-2" />
      {t('subscribe_to_unlock')}
    </button>
  );
};

export default UnlockButton;
